import "./App.css";
import "react-modern-drawer/dist/index.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { UserProvider } from "./pages/userContext";
import Home from "./components/home.component";
import Nav from "./components/nav.component";
import Login from "./components/login.component";
import Register from "./components/register.component";
import { AboutUs } from "./pages/AboutUs";
import { Events } from "./pages/Events";
import Contact from "./pages/ContactUs";
import Support from "./pages/Support";
import CountTable from "./pages/CountTable";
import Rating from "./pages/Rating";
import Reports from "./pages/Reports";
import AddComment from "./pages/AddComment";
import MainLayout from "./components/MainLayout";
import { Services } from "./pages/Services";
import MobileRating from "./pages/MobileRating";
import Footerbar from "./components/Footerbar";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [flag, setFlag] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  let timeout;
 
  // Function to log out user after 2 minutes of inactivity
  const logout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    navigate("/login");
    window.location.reload();
  };
 
  // Function to reset inactivity timer
  const resetTimer = () => {
    clearTimeout(timeout);
    timeout = setTimeout(logout, 900000); //15 minutes
    
  };
 
  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
 
    const handleStorageChange = () => {
      const token = localStorage.getItem("token");
      setIsLoggedIn(!!token);
    };
 
    window.addEventListener("storage", handleStorageChange);
 
    // Event listeners for activity tracking
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);
    window.addEventListener("scroll", resetTimer);
 
    // Start the inactivity timer
    resetTimer();
 
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearTimeout(timeout);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      window.removeEventListener("scroll", resetTimer);
    };
  }, [flag]);
 
  return (
    <UserProvider>
      {/* If path is /mobilerating, only render MobileRating */}
      {location.pathname.includes("/mobilerating") ? (
        <Routes>
          <Route path="/mobilerating" element={<MobileRating />} />
        </Routes>
      ) : (
        <>
          {!isLoggedIn ? (
            <div className="App">
              <Nav />
              <div className="auth-wrapper bgimg">
                <Routes>
                  <Route exact path="/" Component={Home} />
                </Routes>
                <div className="auth-inner" id="pop_up">
                  <Routes>
                    <Route
                      exact
                      path="/login"
                      element={<Login flag={flag} setFlag={setFlag} />}
                    />
                    <Route exact path="/register" Component={Register} />
                  </Routes>
                </div>
              </div>
              <Footerbar />
            </div>
          ) : (
            <Routes>
              <Route path="/" element={<MainLayout isLoggedIn={isLoggedIn} />}>
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/services" element={<Services />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/events" element={<Events />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/support" element={<Support />} />
                <Route path="/counttable" element={<CountTable />} />
                <Route path="/rating" element={<Rating />} />
                <Route path="/addcomment" element={<AddComment />} />
              </Route>
            </Routes>
          )}
        </>
      )}
    </UserProvider>
  );
}
 
export default App;